const resourcesPath = 'resources.';
const buttonPath = 'button.';
const resourceTabPath = 'educationHub.resourceTabLabels.';


const resourcesTrans = {
    FEATURED_CONTENT: resourcesPath + 'featuredContent',
    FEATURED_CONTENT_DESCRIPTION: resourcesPath + 'featuredContentDesc',

    ADDITIONAL_CONTENT: resourcesPath + 'additionalContent',
    ADDITIONAL_CONTENT_DESCRIPTION: resourcesPath + 'additionalContentDesc',

    OFFICE_RESOURCES: resourcesPath + 'officeResources',
    OFFICE_RESOURCES_DESCRIPTION: resourcesPath + 'officeResourcesDesc',
    GA_RESOURCES: resourcesPath + 'gaResources',
    GA_RESOURCES_DESCRIPTION: resourcesPath + 'gaResourcesDesc',

    GA_BY_NUMBERS: resourcesPath + 'gaByNumbers',
    DOWNLOAD_BTN: buttonPath + 'download',

    FOR_EYE_CARE_PROFESSIONALS: resourceTabPath + 'forEyeCareProfessionals',
    FOR_PATIENTS_AND_CAREGIVERS: resourceTabPath + 'ForPatientsAndCaregivers',
}


export default resourcesTrans